// LIB
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// STYLES
import { colors } from './Design_System/DesignSystem';
import './cssgram.css';

// COMPONENT
import Title from './components/molecules/Title';
import Menu from './components/molecules/Menu';
import Home from './components/molecules/Home';
import Info from './components/molecules/Info';
import Password from './components/molecules/Password';
import Contact from './components/molecules/Contact';
import Project from './components/molecules/Project';
import Intro from './components/molecules/Intro';
import Theme from './components/molecules/Theme';
import RandomColor from './components/molecules/RandomColor';
import Language from './components/molecules/Language';
import PrivateBlog from './components/molecules/PrivateBlog/PrivateBlog';
import Blog from './components/molecules/PrivateBlog/Blog';
import AddPersonForm from './components/molecules/PrivateBlog/AddPersonForm';
import ArticleForm from './components/molecules/PrivateBlog/ArticleForm';
import { useLanguage } from './i18n/LanguageContext';

var tabcss = [
  '_1977',
  'aden',
  'brannan',
  'brooklyn',
  'clarendon',
  'earlybird',
  'gingham',
  'hudson',
  'inkwell',
  'kelvin',
  'lark',
  'lofi',
  'maven',
  'mayfair',
  'moon',
  'nashville',
  'perpetua',
  'reyes',
  'rise',
  'slumber',
  'stinson',
  'toaster',
  'valencia',
  'walden',
  'willow',
  'xpro2',
];

localStorage.setItem('a2b9fd36-29a5-41c9-8de9-49ce7e7c9c3c', '');

function isDay() {
  const maintenant = new Date(); // Crée un objet Date représentant l'heure actuelle
  const heure = maintenant.getHours(); // Récupère l'heure actuelle
  return heure >= 7 && heure < 18; // Renvoie true si l'heure est entre 7h et 18h
}

const App = () => {
  const { t } = useLanguage();
  const menuItems = [
    { number: '01.', name: t.menu.home },
    { number: '02.', name: t.menu.info },
    { number: '03.', name: t.menu.projects },
    { number: '04.', name: t.menu.contact },
  ];

  const [selectedItem, setSelectedItem] = useState(0);
  const [item, setItem] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isLightTheme, setIsLightTheme] = useState(isDay());
  const [colorTheme, setColorTheme] = useState('mayfair');
  const [blog, setBlog] = useState({});

  const SelectedItem = (selectedItem) => {
    switch (selectedItem) {
      case 1:
        localStorage.setItem('a2b9fd36-29a5-41c9-8de9-49ce7e7c9c3c', '');
        return <Info setSelectedItem={setSelectedItem} />;
      case 2:
        localStorage.setItem('a2b9fd36-29a5-41c9-8de9-49ce7e7c9c3c', '');
        return <Project />;
      case 3:
        localStorage.setItem('a2b9fd36-29a5-41c9-8de9-49ce7e7c9c3c', '');
        return <Contact />;
      case 4:
        localStorage.setItem('a2b9fd36-29a5-41c9-8de9-49ce7e7c9c3c', '');
        return <Password setSelectedItem={setSelectedItem} />;
      case 7:
        return (
          <PrivateBlog setSelectedItem={setSelectedItem} setBlog={setBlog} />
        );
      case 8:
        return <Blog setSelectedItem={setSelectedItem} blog={blog} />;
      case 9:
        return <AddPersonForm setSelectedItem={setSelectedItem} blog={blog} />;
      case 10:
        return <ArticleForm setSelectedItem={setSelectedItem} blog={blog} />;
      default:
        localStorage.setItem('a2b9fd36-29a5-41c9-8de9-49ce7e7c9c3c', '');
        return <Home />;
    }
  };

  const isComputer = /Windows|Macintosh|Linux/.test(navigator.userAgent);

  function ChangeColor() {
    const randNb = Math.floor(Math.random() * (1 + 26));
    setColorTheme(tabcss[randNb]);
  }

  useEffect(() => {
    // Vérifier l'heure actuelle toutes les minutes
    const interval = setInterval(() => {
      const maintenant = new Date();
      const heure = maintenant.getHours();

      // Si l'heure est 7:00 ou si l'heure est 18:01 ou plus tard, mettre à jour le thème
      if (heure === 7 || heure === 18) {
        setIsLightTheme(isDay());
      }
    }, 60 * 1000); // Vérifier l'heure toutes les minutes

    // Nettoyer l'intervalle lorsque le composant est démonté
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setVisible(false);
    if (item === null) {
      setItem(SelectedItem(selectedItem));
      setVisible(true);
    } else {
      setTimeout(() => {
        setItem(SelectedItem(selectedItem));
        setVisible(true);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  return (
    <>
      <Intro isLightTheme={isLightTheme} />
      <AppContainer className={colorTheme} isLightTheme={isLightTheme}>
        <MainContainer isItemEight={selectedItem === 8}>
          <LeftContainer>
            <Title title="Tristan Lemire" subtitle={t.subtitle} />
            <CustomMenu
              menus={menuItems}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
            />
          </LeftContainer>
          <RightContainer className={visible && 'fade-in'}>
            {item}
          </RightContainer>
        </MainContainer>
        <Theme isLightTheme={isLightTheme} setIsLightTheme={setIsLightTheme} />
        {isComputer && <Language />}
        {isComputer && <RandomColor ChangeColor={ChangeColor} />}
      </AppContainer>
    </>
  );
};

const AppContainer = styled.div`
  background-color: ${(props) =>
    props.isLightTheme ? colors.blue : colors.black};
  transition: background-color 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

const MainContainer = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.isItemEight ? 'flex-start' : 'space-between'};
  border: solid 1px ${colors.tan};
  justify-content: space-between;
  /*   border: solid 1px ${colors.tan}; */
  width: calc(100%);
  min-height: calc(100vh - 85px);
  margin: 40px;
  flex-wrap: wrap;
  border: 15px solid transparent; /* invisible space */
  outline: 2px solid ${colors.tan};
  outline-offset: -10px; /* first box */
  background:
    linear-gradient(${colors.tan} 0 0) top,
    linear-gradient(${colors.tan} 0 0) left,
    linear-gradient(${colors.tan} 0 0) bottom,
    linear-gradient(${colors.tan} 0 0) right;
  background-size:
    200% 4px,
    4px 200%; /* second box */
  background-origin: padding-box;
  background-repeat: no-repeat;
`;
const LeftContainer = styled.div`
  margin-top: 20px;
  margin-left: 20px;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  &.fade-in {
    opacity: 1;
  }
`;

const CustomMenu = styled(Menu)`
  margin-top: 140px;

  @media (max-width: 824px) {
    margin-top: 20px;
  }
`;

export default App;
